module.exports = __webpack_public_path__ + "img/42.9c431345.webp";